import { useIntl } from "react-intl";
import { useStyle } from "./style";
import { Circle20Filled, Circle20Regular } from "@fluentui/react-icons";
import { DesireMenuProps, DesireType } from "./types";
import { desireTypes, desireColors } from "@/common/helpers/supervisorHelper";
import { QueuesState, useQueuesStore } from "@/common/stores/nonpersistingStores/queues";
import { Flex, GapSize } from "@/components/atoms/flex";

export const Desire = (props: DesireMenuProps) => {
	const classes = useStyle();
	const intl = useIntl();
	const queues = useQueuesStore((state: QueuesState) => state.queues);
	const isDisabled = () => {
		const currentQueue = queues.find((y) => y.id === props.data.id);

		return currentQueue?.hasAgentsActivityRight && !currentQueue.isSupervisor;
	};

	const desireTrigger = () => {
		return (
			<Flex gap={GapSize.None} vAlign="center">
				{desireTypes.map((type) => {
					const isSelected = props.data.desire === type;
					const Icon = isSelected ? Circle20Filled : Circle20Regular;
					
					return (
						<span
							key={type}
							title={intl.formatMessage({
								id: `Supervisor.Desire.${DesireType[type]}`,
							})}
							style={{ cursor: "pointer" }}
							onClick={() => {
								if (!isDisabled() && !isSelected) {
									props.onChange(props.data, type);
								}
							}}
						>
							<Icon className={classes.desire} color={desireColors[type]} />
						</span>
					);
				})}
			</Flex>
		);
	};

	return desireTrigger();
};
